wbApp.factory('shoppingCartSvc', ['$q', 'localStorageService', 'orderSvc', 'rentSvc', 'securitySvc',
    function ($q, localStorageService, orderSvc, rentSvc, securitySvc) {

        function createNew() {
            return {};
        }

        function getCartId(forAnonymous) {
            if (!!forAnonymous) {
                return 'wbShoppingCart-anonymous';
            } else {
                return 'wbShoppingCart-' + (securitySvc.loggedInUser().userID || "anonymous");
            }
        }

        function saveShoppingCart(shoppingCart) {
            if (localStorageService.isSupported) {
                localStorageService.set(getCartId(), shoppingCart);
            }
        }

        //rentItem: {
        //    "rentCategoryId": "2qhSydPeXbigOQPFlr1e",
        //    "itemTypeId": "um12WeXPsTn4lb0VpaAx",
        //    "rentCategory": {
        //        "id": "2qhSydPeXbigOQPFlr1e",
        //        "name": "Tenisové kurty",
        //        "shortDescription": "Nově zrekonstruované kurty vedle tělocvičny",
        //        "htmlDescription": "...",
        //        "itemSelectionType": 0,
        //        "rentingPeriodType": 0,
        //        "minimumRentingPeriods": 60,
        //        "maximumRentingPeriods": 120,
        //        "minimumNumberOfRentedItem": 1,
        //        "maximumNumberOfRentedItems": 1,
        //        "pictureUrls": [
        //            "https://u26nfbi1h0-images.storage.googleapis.com/Generic/6/42ee755f-ecaa-40a7-a253-4a58cbcb690a.jpeg"
        //        ],
        //        "accessPermissions": 3,
        //        "isActive": true,
        //        "rentCategoryGroupId": "jrLdCocUxAyjyx5yoUBJ"
        //    },
        //    "startDate": "2021-04-02T12:00:00",
        //    "endDate": "2021-04-02T14:00:00",
        //    "numberOfItemsToAdd": 1,
        //    "rentItem": {
        //        "id": "c6XFRpCjUsKiBCFzFVcO",
        //        "rentCategoryId": "2qhSydPeXbigOQPFlr1e",
        //        "placeId": "10722",
        //        "itemTypeId": "um12WeXPsTn4lb0VpaAx",
        //        "name": "Kurt číslo 3",
        //        "shortDescription": "Kurt vpravo vedle kantýny",
        //        "htmlDescription": "...",
        //        "externalId": "TK03",
        //        "pictureUrls": [
        //            "https://u26nfbi1h0-images.storage.googleapis.com/Generic/6/662f97ce-d6fd-40e5-9702-874fb4743592.jpeg"
        //        ],
        //        "itemCondition": 0
        //    }
        //}
        function addRentItemToShoppingCart(cart, rentItem, placeId) {

            // Find corresponding rent in the Cart
            // Corresponding means it has same PlaceId and same start and end times
            // If not found, create a new rent

            if (!cart.rents) {
                cart.rents = [];
            }

            var tartgetRentCandidate = _.find(cart.rents, function (r) {
                return placeId == r.placeId &&
                    moment(rentItem.startDate).isSame(r.startDate) &&
                    moment(rentItem.endDate).isSame(r.endDate);
            });
            if (!tartgetRentCandidate) {
                tartgetRentCandidate = {
                    placeId: placeId,
                    startDate: rentItem.startDate,
                    endDate: rentItem.endDate,
                    rentedItems: []
                };
                cart.rents.push(tartgetRentCandidate);
            }

            for (var i = 0; i < rentItem.numberOfItemsToAdd; i++) {
                tartgetRentCandidate.rentedItems.push({
                    id: !!rentItem.rentItem ? rentItem.rentItem.id : null,
                    externalId: !!rentItem.rentItem ? rentItem.rentItem.externalId : null,
                    rentCategoryId: rentItem.rentCategoryId || null,
                    itemTypeId: rentItem.itemTypeId || null,

                    // Extra info
                    rentCategory: rentItem.rentCategory,
                    rentItem: rentItem.rentItem
                });
            }

            recalculateShoppingCart(cart);

            saveShoppingCart(cart);
        }

        // Updates summary counts
        function recalculateShoppingCart(cart) {
            if (!cart) {
                return cart;
            }

            if (!cart.rents) {
                cart.rents = [];
            }

            // Clear errors
            delete cart.errors;
            _.forEach(cart.rents, function (r) {
                delete r.hasErrors;
                _.forEach(r.rentedItems, function (ri) {
                    delete ri.hasErrors;
                });
            });

            cart.itemsCount = _.reduce(cart.rents, function (sum, r) {
                return sum = sum + (!!r.rentedItems ? r.rentedItems.length : 0);
            }, 0);
        }

        function removeRentItemFromShoppingCart(cart, rent, index) {
            rent.rentedItems.splice(index, 1);
            if (!rent.rentedItems.length) {

                var rentIndex = cart.rents.indexOf(rent);
                if (rentIndex !== -1) {
                    cart.rents.splice(rentIndex, 1);
                }
            }

            recalculateShoppingCart(cart);

            saveShoppingCart(cart);
        }

        function emptyShoppingCart(cart) {
            cart.rents.length = 0;

            recalculateShoppingCart(cart);

            saveShoppingCart(cart);
        }

        function loadShoppingCart() {

            var shoppingCart = {};

            if (localStorageService.isSupported) {

                var cartLoaded = false;

                var anonymousCartId = getCartId(true);

                if (securitySvc.isAuthenticated()) {
                    // First try to load user's cart
                    var userCartId = getCartId();
                    var userCart = localStorageService.get(userCartId);
                    if (!!userCart && !!userCart.rents && userCart.rents.length > 0) {
                        shoppingCart = userCart;
                        localStorageService.remove(anonymousCartId);
                        cartLoaded = true;
                    }
                    else {
                        // Try to load anonymous cart
                        var anonymousCart = localStorageService.get(anonymousCartId);
                        if (!!anonymousCart) {
                            shoppingCart = anonymousCart;
                            // Delete the anonymous cart
                            localStorageService.remove(anonymousCartId);
                            cartLoaded = true;
                        }
                    }
                }

                if (!cartLoaded) {
                    shoppingCart = localStorageService.get(getCartId()) || shoppingCart;
                }
            }

            recalculateShoppingCart(shoppingCart);

            return shoppingCart;
        }

        // Cart 
        //{
        //    id: null,
        //    userId: null,
        //    studentIds[]: null,
        //    isNotRegisteredUser: false,
        //    publicNotes: null,
        //    orderStatus: 0,
        //    auditEvents: null,
        //    notRegisteredUserInfo: null,
        //    rents: null
        //};


        function rentShoppingCart(cart) {

            var orderModel = orderSvc.createNew();
            orderModel.userId = cart.userId;
            orderModel.studentIds = !!cart.studentId ? [cart.studentId] : [];
            orderModel.isNotRegisteredUser = cart.isNotRegisteredUser;
            orderModel.notRegisteredUserInfo = cart.notRegisteredUserInfo;

            orderModel.rents = _.map(cart.rents || [], function (rent) {
                return rentSvc.modelToDTO({
                    placeId: rent.placeId,
                    rentedItems: _.map(rent.rentedItems || [], function(rentItem) {
                        return {
                            id: rentItem.id,
                            externalId: rentItem.externalId,
                            rentCategoryId: rentItem.rentCategoryId,
                            itemTypeId: rentItem.itemTypeId
                        }
                    }),
                    fromUtc: rent.startDate,
                    toUtc: rent.endDate,
                    status: {
                        status: 0
                    },
                    userId: cart.userId,
                    studentId: cart.studentId,
                    isNotRegisteredUser: cart.isNotRegisteredUser,                    
                })
            });

            return orderSvc.insert(orderModel);
        }


        return {
            createNew: createNew,

            addRentItemToShoppingCart: addRentItemToShoppingCart,
            loadShoppingCart: loadShoppingCart,
            saveShoppingCart: saveShoppingCart,
            rentShoppingCart: rentShoppingCart,
            removeRentItemFromShoppingCart: removeRentItemFromShoppingCart,
            emptyShoppingCart: emptyShoppingCart,
        }
    }
]);